enum ReactQueryKeyEnum {
  Organizations = 'organizations',
  Employees = 'employees',
  Status = 'status',
}

export default ReactQueryKeyEnum;
